import { render } from "./CartVerification.vue?vue&type=template&id=3b0120c4"
import script from "./CartVerification.vue?vue&type=script&lang=js"
export * from "./CartVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__